import debug from './debug'
import swal from 'sweetalert2'
var PI = 3.14159265358979324

function delta(lat, lon) {
	var a = 6378245.0
	var ee = 0.00669342162296594323
	var dLat = transformLat(lon - 105.0, lat - 35.0)
	var dLon = transformLon(lon - 105.0, lat - 35.0)
	var radLat = (lat / 180.0) * PI
	var magic = Math.sin(radLat)
	magic = 1 - ee * magic * magic
	var sqrtMagic = Math.sqrt(magic)
	dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * PI)
	dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * PI)
	return { lat: dLat, lon: dLon }
}

function outOfChina(lat, lon) {
	if (lon < 72.004 || lon > 137.8347) return true
	if (lat < 0.8293 || lat > 55.8271) return true
	return false
}

function transformLat(x, y) {
	var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
	ret += ((20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0) / 3.0
	ret += ((20.0 * Math.sin(y * PI) + 40.0 * Math.sin((y / 3.0) * PI)) * 2.0) / 3.0
	ret += ((160.0 * Math.sin((y / 12.0) * PI) + 320 * Math.sin((y * PI) / 30.0)) * 2.0) / 3.0
	return ret
}

function transformLon(x, y) {
	var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
	ret += ((20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0) / 3.0
	ret += ((20.0 * Math.sin(x * PI) + 40.0 * Math.sin((x / 3.0) * PI)) * 2.0) / 3.0
	ret += ((150.0 * Math.sin((x / 12.0) * PI) + 300.0 * Math.sin((x / 30.0) * PI)) * 2.0) / 3.0
	return ret
}

/**
 * GPS 转换调用接口（GPS 转 高德坐标）
 * @param { * } wgsLon 经度
 * @param { * } wgsLat 纬度
 */
function encryptGPS(wgsLon, wgsLat) {
	if (outOfChina(wgsLat, wgsLon)) return { lat: wgsLat, lon: wgsLon }

	var d = delta(wgsLat, wgsLon)

	var resLat = Number(wgsLat) + Number(d.lat)
	var resLon = Number(wgsLon) + Number(d.lon)
	return {
		latitude: Number(resLat).toFixed(6),
		longitude: Number(resLon).toFixed(6)
	}
}

function decryptGPS(aLon, aLat) {
	var dev = delta(aLat, aLon)
	var retLat = aLat - dev.lat
	var retLon = aLon - dev.lon
	dev = delta(retLat, retLon)
	retLat = aLat - dev.lat
	retLon = aLon - dev.lon
	return {
		latitude: Number(retLat).toFixed(6),
		longitude: Number(retLon).toFixed(6)
	}
}

/**
 * 获取硬件GPS位置(未纠偏)
 * @param { * } navigator Plugin name
 *
 * position.coords { latitude, longitude }
 */
function getBaseGPS(navigator) {
	return new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(
			position => {
				debug.log('Get base GPS information successfully')
				resolve(position.coords)
			},
			error => {
				debug.log('Can\'t get base GPS information')
				reject(error)
			},
			{ enableHighAccuracy: true, timeout: 5000 }
		)
	})
}

/**
 * 检测是否存在Amap App，若是不存在则无法使用Amap导航
 * @param { * } appAvailability Plugin name
 */
function isAmapExist(appAvailability, platform) {
	var uri = 'com.autonavi.minimap'
	if (platform == 'iOS')
		uri = 'iosamap://'
	return new Promise((resolve, reject) => {
		appAvailability.check(
			uri,
			() => {
				debug.log('Amap exist')
				resolve()
			},
			() => {
				swal.fire({
					text: '您尚未安装高德地图',
					title: '导航失败',
					type: 'error',
					showConfirmButton: false,
					timer: 1000,
				})
				reject()
			}
		)
	})
}

/**
 * 检测百度地图是否存在
 * @param { * } appAvailability Plugin name
 */
function isBaiduMapExist(appAvailability, platform) {
	var uri = 'com.baidu.BaiduMap'
	if (platform == 'iOS')
		uri = 'baidumap://'
	return new Promise((resolve, reject) => {
		appAvailability.check(
			uri,
			() => {
				debug.log('Baidu map exist')
				resolve()
			},
			() => {
				swal.fire({
					text: '您尚未安装百度地图',
					title: '导航失败',
					type: 'error',
					showConfirmButton: false,
					timer: 1000,
				})
				reject()
			}
		)
	})
}

/**
 * 打开地图并导航到 destination 所指向地点
 * @param { * } startApp Plugin name
 * @param { * } destination = {latitude: value, longitude: value}
 */
function startAmap(startApp, midpoints, source, destination, platform) {
	if (source != null) {
		var srclati = Number(source.latitude).toFixed(6)
		var srclongi = Number(source.longitude).toFixed(6)
	}

	var lati = Number(destination.latitude).toFixed(6)
	var longi = Number(destination.longitude).toFixed(6)

	return new Promise((resolve, reject) => {
		if (source == null) {
			var uri = `androidamap://navi?sourceApplication=appname&poiname=fangheng&lat=${lati}&lon=${longi}&dev=0&style=2`
		} else {
			uri = `amapuri://route/plan/?sid=BGVIS1&slat=${srclati}&slon=${srclongi}&sname=起点&did=BGVIS2&dlat=${lati}&dlon=${longi}&dname=终点&dev=0&t=0`
		}
		var sApp = startApp.set({
			/* params */
			action: 'ACTION_VIEW',
			category: 'CATEGORY_DEFAULT',
			type: 'text/css',
			package: 'com.autonavi.minimap',
			uri: uri,
			flags: ['FLAG_ACTIVITY_CLEAR_TOP', 'FLAG_ACTIVITY_CLEAR_TASK'],
			intentstart: 'startActivity'
		})
		if (platform == 'iOS') {
			if (source == null) {
				uri = `iosamap://navi?sourceApplication=appname&poiname=fangheng&lat=${lati}&lon=${longi}&dev=0&style=2`
			} else {
				uri = `iosamap://path/?sourceApplication=appname&sid=BGVIS1&slat=${srclati}&slon=${srclongi}&sname=&did=BGVIS2&dlat=${lati}&dlon=${longi}&dname=&dev=0&t=0`



			}
			sApp = startApp.set(uri)
		}
		sApp.start(
			function () {
				debug.log('Start app successfully')
				resolve()
			},
			function (error) {
				debug.log('Start app fail\n' + 'error code: ' + error)
				reject()
			}
		)
	})
}

function startBaiduMap(startApp, midpoints, source, destination, platform) {
	if (source != null) {
		var srclati = Number(source.latitude).toFixed(5)
		var srclongi = Number(source.longitude).toFixed(5)
	}
	var lati = Number(destination.latitude).toFixed(5)
	var longi = Number(destination.longitude).toFixed(5)

	var tmpList = new Array()

	for (var index = 0; index < midpoints.length; index++) {
		var tmpLati = Number(midpoints[index].latitude).toFixed(5)
		var tmpLongi = Number(midpoints[index].longitude).toFixed(5)
		var tmpName = midpoints[index].name
		tmpList[index] = { name: tmpName, lat: tmpLati, lng: tmpLongi }
	}

	var viaPoints = ''
	if (tmpList.length != 0) {
		viaPoints = `&viaPoints=${JSON.stringify({ viaPoints: tmpList })}`
	}

	var packageName = 'com.hzdatalink.eds'

	let uri
	if (source == null) {
		uri = `baidumap://map/direction?destination=name:工地|latlng:${lati},${longi}&mode=driving${viaPoints}&src=${packageName}`
	} else {
		uri = `baidumap://map/direction?origin=name:起点|latlng:${srclati},${srclongi}&destination=name:工地|latlng:${lati},${longi}&mode=driving${viaPoints}&src=${packageName}`
	}
	debug.log(uri)
	uri = encodeURI(uri)
	debug.log(uri)
	return new Promise((resolve, reject) => {

		var sApp = startApp.set({
			/* params */
			action: 'ACTION_VIEW',
			category: 'CATEGORY_DEFAULT',
			type: 'text/css',
			package: 'com.baidu.BaiduMap',
			uri: uri,
			flags: ['FLAG_ACTIVITY_CLEAR_TOP', 'FLAG_ACTIVITY_CLEAR_TASK'],
			intentstart: 'startActivity'
		})
		if (platform == 'iOS') {
			sApp = startApp.set(uri)
		}
		sApp.start(
			function () {
				debug.log('Start app successfully')
				resolve()
			},
			function (error) {
				debug.log('Start app fail\n' + 'error code: ' + error)
				reject()
			}
		)
	})
}

var StaticMap = {
	data: {
		// 对应包名 com.ids.claude
		KEY: '3f45d44282da372e3ff0b29cc5cdffba',
		baseUrl: 'https://restapi.amap.com/v3/staticmap'
	},
	/**
	 *
	 * @param { * } configure 配置
	 * conifgure = {
	 *    size: {
	 *      length: 800,
	 *      width: 800
	 *    },
	 *    markers: {
	 *      size: "large",
	 *      color: "0xfff000",
	 *      labels: ["C", "D"],
	 *      locations: [
	 *        { latitude: 34.120911, longitude: 113.295135 },
	 *        { latitude: 34.121077, longitude: 113.299877 }
	 *      ]
	 *    }
	 *  }
	 *
	 */
	getLabeledStaticMap: function (configure) {
		var result = `${this.data.baseUrl}?`

		if (configure.markers != undefined) {
			var markers = configure.markers
			if (['small', 'mid', 'large'].indexOf(markers.size) < 0) {
				markers.size = 'mid'
			}
			const regex = /0x[0-9 a-f A-F]{6}/
			if (regex.exec(markers.color) == null) {
				markers.color = '0xFF0000'
			}
			if (markers.labels == undefined) {
				markers.labels[0] = 'A'
				markers.labels[1] = 'B'
			}
			result += 'markers='
			for (var index = 0; index < markers.locations.length; ++index) {
				var tmpLoc = markers.locations[index]
				debug.log(tmpLoc.latitude)
				tmpLoc.latitude = Number(tmpLoc.latitude).toFixed(6)
				tmpLoc.longitude = Number(tmpLoc.longitude).toFixed(6)
				if (index != 0) {
					result += '|'
				}
				result += `${markers.size},${markers.color},${markers.labels[0]}:${tmpLoc.longitude},${tmpLoc.latitude}`
			}
		}

		if (configure.size != undefined) {
			var tlength = configure.size.length
			var twidth = configure.size.width

			var length = tlength > 1024 ? 1024 : tlength
			var width = twidth > 1024 ? 1024 : twidth

			result += `&size=${width}*${length}`
		}
		result += `&key=${this.data.KEY}`
		debug.log(result)
		return result
	}
}

export { encryptGPS, decryptGPS, getBaseGPS, isAmapExist, startAmap, StaticMap, isBaiduMapExist, startBaiduMap }
